/** Payable bags = min(party invoice, unloaded) when both are known. */
export function billableBagsPreview(unloaded, partyInvoice) {
  const u =
    unloaded !== "" && unloaded != null && !Number.isNaN(Number(unloaded))
      ? Math.max(0, Number(unloaded))
      : null;
  const i =
    partyInvoice !== "" && partyInvoice != null && !Number.isNaN(Number(partyInvoice))
      ? Math.max(0, Number(partyInvoice))
      : null;
  if (i != null && u != null && u > 0) return Math.min(i, u);
  if (i != null) return i;
  if (u != null && u > 0) return u;
  return null;
}

export function bagsSettlementHelp(unloaded, partyInvoice, billable) {
  const u = unloaded != null ? Number(unloaded) : null;
  const i = partyInvoice != null ? Number(partyInvoice) : null;
  if (i != null && u != null && u > 0 && billable != null && i !== u) {
    return `Payable bags: ${billable} (lower of invoice ${i} and unloaded ${u})`;
  }
  if (billable != null) return `Payable bags: ${billable}`;
  return "Enter party invoice bags; unloaded count comes from unloading.";
}
